import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import clsx from 'clsx';
import { ritzDataContext, selectProjectById } from '@moderepo/mode-data-state-ritz';
import { ProjectDashboardSettingsContainer } from './ProjectDashboardSettingsContainer';


export const ProjectDashboardSettingsPage: React.FC = () => {
    const params = useParams();
    const projectId = Number(params.projectId);

    const { state:dataState } = useContext(ritzDataContext);
    const project = selectProjectById(dataState, projectId);


    return (
        <div className={clsx('page-main-content')}>
            <div className="title-bar">
                <div className="title-bar-item title-text">
                    <div className="page-title">
                        Project Dashboard Settings
                    </div>
                    <div className="page-subtitle">
                        Project Dashboard Settings for project (<b>{project?.name}</b>)
                    </div>
                </div>
            </div>

            {project && (
                <ProjectDashboardSettingsContainer projectId={project.id} />
            )}

            {!project && (
                <CircularProgress />
            )}
        </div>
    );
};
